import { render, staticRenderFns } from "./HistoricoJustificativaFaltaDialog.vue?vue&type=template&id=ab05beca"
import script from "./HistoricoJustificativaFaltaDialog.vue?vue&type=script&lang=js"
export * from "./HistoricoJustificativaFaltaDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports